import React, { useState } from "react";
import { Button, Menu, MenuItem } from '@mui/material';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { materialsymbolsdownload, wg_report_logo } from 'images';
import dayjs from 'dayjs';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { convertToBase64 } from '_utils';
const ActivityDownload = ({ data, selectedDate, toDate,fromDate,portalID }) => {

    const [anchorEl, setAnchorEl] = useState(null);
const portals = [
    { PortalId: 1, PortalName: "Account Inquiry" },
    { PortalId: 2, PortalName: "Energy Assistance" },
    { PortalId: 3, PortalName: "Map Center" },
    { PortalId: 4, PortalName: "Marketer & BBS" },
    { PortalId: 5, PortalName: "Supplier Diversity" }
  ];

  const filterPortalName = portals.filter(item => item.PortalId == portalID);
  
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const exportToExcel = async() => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Activity Log");

        // Add header and date published
        sheet.mergeCells("A1", "C1");
        sheet.getCell("A1").value = "Activity Log";
        sheet.getCell("A1").font = { size: 16, bold: true };

        sheet.mergeCells("A2", "C2");
        sheet.getCell("A2").value = `Portal Name: ${filterPortalName[0]?.PortalName}`;
        sheet.getCell("A2").font = { bold: true }; 
        sheet.mergeCells("A3", "C3");
        sheet.getCell("A3").value = `Date Range: ${dayjs(fromDate).format("MM/DD/YYYY")} - ${dayjs(toDate).format("MM/DD/YYYY")}`;
        sheet.getCell("A3").font = { bold: true }; 

        sheet.mergeCells("A4", "C4");
        sheet.getCell("A4").value = `Date Published: ${dayjs().format("MM/DD/YYYY")}`;
        sheet.getCell("A4").font = { bold: true }; 

             // Add logo to top-right
        //Add logo image
        const response = await fetch(wg_report_logo);
        const imageBlob = await response.blob();
        const base64 = await convertToBase64(imageBlob);

        const imageId = workbook.addImage({
            base64: base64,
            extension: "png", // or "jpeg"
        });

        // Place logo at cell E1
        sheet.addImage(imageId, {
            tl: { col: 3, row: 0 }, // top-left: E1
            ext: { width: 170, height: 60 },
        });
        sheet.addRow([]);

        const tableColumnHeaders = [
            "Time Stamp",
            "User Email Address",
            "Organization",
            "Activity",
            "Details",
            "Status"
          ];
          const headerRow = sheet.addRow(tableColumnHeaders);
          headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // white bold text
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF4472C4' }, // blue background
            };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' },
            };
        });
          data?.forEach(item => {
            sheet.addRow([
              dayjs(item.CreatedOn).format("MM/DD/YYYY hh:mm A"), // Time Stamp
              item.UserName,                                       // User Email Address
              item.Organization,                                   // Organization
              item.Activity,                                       // Activity
              item.ActivityDetails,                                // Details
              item.StatusText                                       // Status
            ]);
          });
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, "Activity_log.xlsx");
      };
      const exportToPDF = () => {
        const doc = new jsPDF();
        const imgWidth = 65; 
        const imgHeight = 20; 
        const pageWidth = doc.internal.pageSize.getWidth();
        const margin = 10;

        doc.setFontSize(16);
        doc.text("Activity Log", 14, 20);
        doc.addImage(wg_report_logo , 'PNG', pageWidth - imgWidth - margin, 15, imgWidth, imgHeight);
        doc.setFontSize(12); 
        doc.text(`Portal Name: ${filterPortalName[0]?.PortalName}`, 14, 30);
        doc.text(`Date Range: ${dayjs(fromDate).format("MM/DD/YYYY")} - ${dayjs(toDate).format("MM/DD/YYYY")}`, 14, 38);
        // doc.text(`Date Range: ${dayjs(fromDate).format("MM/DD/YYYY")} - ${dayjs(toDate).format("MM/DD/YYYY")}`, 14, 38);
        doc.text(`Date Published: ${dayjs().format("MM/DD/YYYY")}`, 14, 46);
       
        const tableColumnHeaders = [
            "Time Stamp",
             "User Email Address",
            "Organization",
            "Activity",
            "Details",
            "Status"
           
          ];

          const tableRows = data?.map(item => ([
            dayjs(item.CreatedOn).format("MM/DD/YYYY hh:mm A"),
            item.UserName || "",
            item.Organization || "",
            item.Activity || "",
            item.ActivityDetails || "",
            item.Status ? "Success" : "Failure"
          ]));
          const totalPagesExp = "{{pageCount}}";
          doc.autoTable({
            head: [tableColumnHeaders],
            body: tableRows,
            startY: 54,
            styles: {
              fontSize: 10,
              cellPadding: 3,
            },
            headStyles: {
              fillColor: "#0F3557",
              textColor: "white",
              fontStyle: "bold"
            },
            columnStyles: {
                0: { cellWidth: 25}, 
                1: { cellWidth: 35},   
                4: { cellWidth: 40 }, // Increase width of "Details" column (index 4)
                5: { cellWidth: 20}  
            },
            didDrawPage: function (data) {
                const pageHeight = doc.internal.pageSize.height;
                doc.setFontSize(10);
                // doc.text('Quantity: Dth Dry',14, pageHeight - 10);
                // Add page number
                doc.text(`Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${totalPagesExp}`, doc.internal.pageSize.width - 40, pageHeight - 10);
              },
          });
          doc.putTotalPages(totalPagesExp);
          doc.save("ActivityLog_Report.pdf");
        //   const tableRows = [];
        //   data?.NominationReportData?.forEach((item) => {
           
        //     const row = [];
        //     // row.push({ content: item.TotalNominationAllocations?.toLocaleString() || 0,styles:item.isTotal?{ fillColor: "#0F3557", textColor: "white", fontSize: 10,fontStyle: 'bold', }:{} });
        //     row.push({ content: item.MarketerName || "",styles:item.isTotal?{ fillColor: "#0F3557", textColor: "white", fontSize: 10,fontStyle: 'bold', }:{} });
        //     row.push({ content: item?.CustomerAccount || "",styles:item.isTotal?{ fillColor: "#0F3557", textColor: "white", fontSize: 10,fontStyle: 'bold', }:{}});
        //     row.push({ content: item?.CustomerReallocatedVolume?.toLocaleString() || "",styles:item.isTotal?{ fillColor: "#0F3557", textColor: "white", fontSize: 10,fontStyle: 'bold', halign: 'right'}:{halign: 'right'} });
        //     row.push({ content: item?.TotalReallocatedVolume?.toLocaleString() || '',styles:item.isTotal?{ fillColor: "#0F3557", textColor: "white", fontSize: 10,fontStyle: 'bold', halign: 'right'}:{halign: 'right'} });
        //     row.push({ content: item?.TotalDCNomination?.toLocaleString() || '',styles:item.isTotal?{ fillColor: "#0F3557", textColor: "white", fontSize: 10,fontStyle: 'bold', halign: 'right'}:{halign: 'right'} });
      
         
      
        //     tableRows.push(row);
        //   });
        // doc.save("CustomerUsage_Report.pdf");
      };
      
      
    const handleDownload = (format) => {
        try {
            const workbook = XLSX.utils.book_new();
            const worksheetData = [
                [""], // Empty row
                ["", "Summary Adjustment Activity Interruptible", "", "", ""], // Header
                [], // Empty row
                ["", `For the month ${dayjs(selectedDate).format('MMMM')}`, "", "", ""], // Dynamic month
                [], // Empty row
                [], // Empty row
                ["", `Date published: ${dayjs().format('MM/DD/YYYY')}`, "", "", ""], // Date published
                [], // Empty row
                [], // Empty row
                ["", "GROUP", "IMBALANCE - FOM", "NOMINATIONS", "USAGE", "ADJUSTMENT", "DRV", "IMBALANCE - EOM", "±15% TOLERANCE", ">15% TOLERANCE"], // Table headers
                ...data.InterruptibleData.map(item => [
                    "",
                    item.AllocationGroup,
                    { v: item.PreviousBalanceInterruptible, t: 'n', z: '0,0' }, // Right align with 10 & 100 format
                    { v: item.TotalNominationAllocations, t: 'n', z: '0,0' }, // Right align with 10 & 100 format
                    { v: item.TotalUsage, t: 'n', z: '0,0' }, // Right align with 10 & 100 format
                    { v: item.ImbalanceAdjustedVolume, t: 'n', z: '0,0' },
                    { v: item.DailyRequiredVolume, t: 'n', z: '0,0' },
                    { v: item.MonthEndImbalanceInterruptible, t: 'n', z: '0,0' },
                    { v: item.ThresholdValue, t: 'n', z: '0,0' },
                    { v: item.OutsideThresholdAmount, t: 'n', z: '0,0' }
                ])
            ];

            const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
            worksheet['!merges'] = [
                { s: { r: 1, c: 1 }, e: { r: 1, c: 4 } }, // Merge B2:F2
                { s: { r: 3, c: 1 }, e: { r: 3, c: 4 } }, // Merge B4:F4
                { s: { r: 6, c: 1 }, e: { r: 6, c: 3 } }, // Merge B7:D7
            ];

            worksheet['!cols'] = [
                { wch: 0 }, // Column A
                { wch: 20 }, // Column B
                { wch: 30 }, // Column C
                { wch: 30 }, // Column D
                { wch: 30 }, // Column E
                { wch: 30 }, // Column E
                { wch: 30 }, // Column E
                { wch: 30 }, // Column E
                { wch: 30 }, // Column E
                { wch: 30 }, // Column E
            ];

            XLSX.utils.book_append_sheet(workbook, worksheet, "Summary Adjustment Activity Int");

            // if (format === 'xls') {
            //     XLSX.writeFile(workbook, "Summary Adjustment Activity Interruptible.xls");
            // } else 
            if (format === 'xlsx') {
                XLSX.writeFile(workbook, "Summary Adjustment Activity Interruptible.xlsx");
            } else if (format === 'pdf') {
                const doc = new jsPDF();
                autoTable(doc, {
                    head: [ ["GROUP", "IMBALANCE - FOM", "NOMINATIONS", "USAGE", "ADJUSTMENT", "DRV", "IMBALANCE - EOM", "±15% TOLERANCE", ">15% TOLERANCE"], // Table headers
                ],
                    body: data.InterruptibleData.map(item => [
                        item.AllocationGroup,
                        item.PreviousBalanceInterruptible,
                        item.TotalNominationAllocations,
                        item.TotalUsage,
                        item.ImbalanceAdjustedVolume,
                        item.DailyRequiredVolume,
                        item.MonthEndImbalanceInterruptible,
                        item.ThresholdValue,
                        item.OutsideThresholdAmount
                    ])
                });
                doc.save('Summary Adjustment Activity Interruptible.pdf');
            } else if (format === 'csv') {
                const csvData = XLSX.utils.sheet_to_csv(worksheet);
                const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement("a");
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", "Summary Adjustment Activity Interruptible.csv");
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }

            handleClose();
        } catch (error) {
            console.error("Error generating the report:", error);
        }
    };

    return (
        <>
            <Button
                variant="contained"
                className='Download'
                color="primary"
                onClick={handleClick}
            >
                <img src={materialsymbolsdownload} alt="Download" /> Download
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={exportToExcel}>Excel</MenuItem>
                {/* <MenuItem onClick={exportToPDF}>CSV</MenuItem> */}
                <MenuItem onClick={exportToPDF}>PDF</MenuItem>
            </Menu>
        </>
    );
};

export default ActivityDownload;